import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import Seo, { SITE_URL } from "@/components/feature/Seo";
import ComicCard from "@/components/feature/ComicCard";
import { comics, comicGenres } from "@/mocks/comics";

export default function Series() {
  const [params, setParams] = useSearchParams();
  const activeGenre = params.get("genre") || "全部";

  const genres = useMemo(() => ["全部", ...comicGenres.map((g) => g.name)], []);
  const list = useMemo(
    () => (activeGenre === "全部" ? comics : comics.filter((c) => c.genre === activeGenre)),
    [activeGenre]
  );

  return (
    <>
      <Seo
        title="全部连载漫画列表 - 天天漫画网"
        description="浏览天天漫画网全部长期连载漫画，支持按热血、科幻、奇幻、日常、悬疑、冒险等题材筛选，稳定更新不断更，追更神器在手。"
        keywords="连载漫画,长篇漫画,漫画分类,热血漫画,科幻漫画,追更"
        canonical={`${SITE_URL}/series`}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            name: "全部连载漫画列表",
            url: `${SITE_URL}/series`,
            description: "天天漫画网全部长期连载漫画，稳定更新不断更。",
          },
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "首页", item: SITE_URL },
              { "@type": "ListItem", position: 2, name: "全部连载", item: `${SITE_URL}/series` },
            ],
          },
        ]}
      />

      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <nav aria-label="面包屑" className="flex items-center gap-1.5 text-xs text-foreground-500">
          <a href="/" className="hover:text-primary-600">首页</a>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-foreground-700">全部连载</span>
        </nav>

        <div className="mt-5">
          <h1 className="font-heading text-2xl text-foreground-950 md:text-3xl">全部连载漫画</h1>
          <p className="mt-2 max-w-2xl text-sm text-foreground-600">
            汇聚天天漫画网全部长期连载长篇漫画，稳定更新不断更，按喜好筛选题材，即刻开启追更。
          </p>
        </div>

        <div className="mt-6 flex flex-wrap gap-2">
          {genres.map((g) => {
            const active = activeGenre === g;
            return (
              <button
                key={g}
                onClick={() => setParams(g === "全部" ? {} : { genre: g })}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                  active
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-700 hover:bg-background-200"
                }`}
              >
                {g}
              </button>
            );
          })}
        </div>

        <div className="mt-6 flex items-center justify-between">
          <p className="text-sm text-foreground-600">
            共 <strong className="text-primary-600">{list.length}</strong> 部{activeGenre === "全部" ? "" : `「${activeGenre}」`}连载漫画
          </p>
        </div>

        <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 md:gap-5">
          {list.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </>
  );
}